<template>
  <div class="agreement-wrapper">
    <el-dialog :visible="dialogVisible" width="1100px" :before-close="handleClose">
      <div class="modal-wrapper">
        <div class="modal-body">
          <iframe width="100%" height="100%" frameborder="0" :src="src"></iframe>
        </div>
        <div class="modal-footer">
          <el-checkbox v-model="isArgument">已阅读并同意上述协议</el-checkbox>
          <el-button :type="isArgument ? 'primary' : ''" :class="isArgument ? '' : 'disabled'" @click="handleSubmit">
            确认并签署协议
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ds-agreement',
  props: {
    submit: { type: Function },
    src: { type: String }
  },
  data() {
    return {
      isArgument: '',
      dialogVisible: false
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    handleSubmit() {
      if (this.isArgument) {
        this.submit().then(() => {
          this.dialogVisible = false;
        });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.isArgument = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.agreement-wrapper {
  /deep/.el-dialog__headerbtn {
    display: unset;
  }

  /deep/.el-dialog__body {
    padding: unset;
  }

  .modal-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 75vh;

    .modal-body {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      box-sizing: border-box;
      overflow-y: auto;
    }

    .modal-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      height: 60px;
      border-top: 1px solid #f2f2f2;

      .disabled {
        color: #c0c4cc;
        background-image: none;
        background-color: #fff;
        border-color: #ebeef5;
      }
    }
  }
}
</style>
